import { useAuthContext } from "contexts/AuthContext"
import { useGlobalAlert } from "contexts/GlobalAlertContext"
import { useState } from "react"
import { studentRequest } from "services/requests"

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)
  const { showAlert } = useGlobalAlert()
  const { selectedGroupData } = useAuthContext()

  const getStundentNotes = async (noteId = 0) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `notes?noteId=${noteId}`,
      body: null,
      method: "get",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return response.data || []
  }

  const createStudentNote = async ({ noteTypeId, title, note }) => {
    setIsFetching(true)
    console.log(`StudentNote: ${noteTypeId}, ${title}, ${note}`)
    const response = await studentRequest.sendRequest({
      endpoint: `notes`,
      body: { noteTypeId, title, note },
      method: "post",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return response.data
  }

  const updateStudentNote = async ({ noteId, title, note }) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `notes/${noteId}`,
      body: { title, note, favorite: true },
      method: "post",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return response.data
  }

  const deleteStudentNote = async (noteId) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `notes/${noteId}`,
      body: null,
      method: "delete",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return response.data
  }

  const getStudentNoteUpdateDate = async (noteId) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `notes/lastUpdate/${noteId}`,
      body: null,
      method: "get",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return response.data
  }

  const searchUser = async (username) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `notes/link/find/${username}`,
      body: null,
      method: "get",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return response.data
  }

  const addLink = async ({ noteId, username, allowEdit }) => {
    setIsFetching(true)
    const user = await searchUser(username)
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!user || user.userId === 0) {
      showAlert("User not found", teacherImage)
      setIsFetching(false)
      return null
    }
    const userId = user.userId
    const response = await studentRequest.sendRequest({
      endpoint: `notes/link`,
      body: { noteId, userId, allowEdit },
      method: "post",
    })
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return {
      ...response.data,
      ...user,
    }
  }

  const getUsersLinked = async (noteId) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `notes/link/${noteId}`,
      body: null,
      method: "get",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return response.data?.users || []
  }

  const deleteLink = async (noteId, userId) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `notes/link/${noteId}/${userId}`,
      body: null,
      method: "delete",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return response.data
  }

  const updateLink = async (noteId, userId, allowEdit) => {
    setIsFetching(true)
    const response = await studentRequest.sendRequest({
      endpoint: `notes/link/update`,
      body: { noteId, userId, allowEdit },
      method: "post",
    })
    const teacherImage = selectedGroupData?.teachers?.[0]?.avatar
    if (!response.success) showAlert(response.message, teacherImage)
    setIsFetching(false)
    return response.data
  }

  return {
    getStundentNotes,
    createStudentNote,
    deleteStudentNote,
    updateStudentNote,
    getStudentNoteUpdateDate,
    searchUser,
    addLink,
    getUsersLinked,
    deleteLink,
    updateLink,
    isFetching,
  }
}

export default useApi
